export const HARD_SESSION_LIMIT_KEYS = {
	hgcHardSessionLimitMessage: "hgc.session-limit-notification.system.10",
	lessThanMinute: "general.less-than-minute",
	infoIcon: "general.info-icon",
	minutes: "general.minutes",
};
